import { IsFeatureEnabledOrNot } from "src/FeatureToggles/FeatureEnabledOrNot";
import { ToggleList } from "src/FeatureToggles/toggleList";

export function useIsIndividualInclusionNamingEnabled():boolean {
  return IsFeatureEnabledOrNot(ToggleList.IndividualInclusionNaming);
}
